

export const categoires=[
    {id:1,type:'Music'},
    {id:2,type:'Sports'},
    {id:3,type:'Tech'},
    {id:4,type:'Movies'}
]